import { PageProps } from '@react-pdf/renderer'

import { ReportsType } from '@features/reports/enums/reportsType'

import { ReportsPdfDocumentVariant } from '../../../types/reportsPdfDocument'
import { getBalanceSheetPageOrientation } from './getBalanceSheetPageOrientation'
import { getProfitAndLossPageOrientation } from './getProfitAndLossPageOrientation'

export const getPageOrientation = (variant: ReportsPdfDocumentVariant): PageProps['orientation'] => {
  switch (variant.reportType) {
    case ReportsType.ProfitAndLoss:
      return getProfitAndLossPageOrientation(variant.appliedFilters)

    case ReportsType.BalanceSheet:
      return getBalanceSheetPageOrientation(variant.appliedFilters)

    case ReportsType.TrialBalance:
      return 'portrait'

    default:
      return 'portrait'
  }
}
